import { Component, HostBinding } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnterpriseConfigurationDataAccessService } from '../../shared/modules/enterprise-configuration/enterprise-configuration-data-access.service';

export type FooterMode = 'default' | 'signOn';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @HostBinding('class.site-footer') public siteFooter: boolean = true;

  public currentYear: number = new Date().getFullYear();
  public logoUrl: SafeResourceUrl | undefined;
  public logoAnchorUrl: SafeUrl | undefined;
  public copyrightHolder: SafeHtml | undefined;
  public legalAnchorUrl: SafeUrl | undefined;
  public contactSalesAnchorText: string | undefined;
  public contactSalesAnchorUrl: SafeUrl | undefined;
  public contactSupportAnchorText: string | undefined;
  public contactSupportAnchorUrl: SafeUrl | undefined;
  public isMasterCardUser: boolean | undefined;
  public mode$: Observable<FooterMode>;

  constructor(
    private enterpriseConfigurationService: EnterpriseConfigurationDataAccessService,
    sanitizer: DomSanitizer,
    _activatedRoute: ActivatedRoute,
  ) {
    this.mode$ = _activatedRoute.data.pipe(
      map((data) => {
        return !!data && data.mode ? data.mode : 'default';
      }),
    );
    enterpriseConfigurationService.getEnterpriseConfiguration().subscribe((configuration) => {
      if (configuration.footerLogoUrl) {
        this.logoUrl = sanitizer.bypassSecurityTrustResourceUrl(configuration.footerLogoUrl);
      }
      if (configuration.footerLogoAnchorUrl) {
        this.logoAnchorUrl = sanitizer.bypassSecurityTrustUrl(configuration.footerLogoAnchorUrl);
      }
      this.copyrightHolder = sanitizer.bypassSecurityTrustHtml(configuration.copyrightHolder);
      if (configuration.legalAnchorUrl) {
        this.legalAnchorUrl = sanitizer.bypassSecurityTrustUrl(configuration.legalAnchorUrl);
      }
      this.isMasterCardUser = configuration.isMasterCardUser;
      this.contactSalesAnchorText = configuration.contactSalesAnchorText;
      this.contactSalesAnchorUrl = configuration.contactSalesAnchorUrl;
      this.contactSupportAnchorText = configuration.contactSupportAnchorText;
      if (configuration.contactSupportAnchorUrl) {
        this.contactSupportAnchorUrl = sanitizer.bypassSecurityTrustUrl(configuration.contactSupportAnchorUrl);
      }
    });
  }
}
